import { hasBaseRole } from '@/helpers/customRoles';
import s from './BodyModal.module.css'
import * as Input from '../../../UI/InputNew'
import { useInputNew } from '@UI/InputNew/useInputNew'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import {
  API,
  classApi,
  directionAPI,
  directionGroupApi,
  directionOrdersApi,
  supportAPI,
  timetableBeta,
  usersAPI,
} from '../../../../api'
import cn from 'classnames'
import update from 'immutability-helper'
import Button from '../../../UI/Button'
import { getAvatar } from '@/helpers/getAvatar'
import { useDispatch, useSelector } from 'react-redux'
import { getRolesSD } from '@/selectors'
import { formateName } from '@/helpers/formateName'
import { useLoad } from '@/hooks/useLoad'
import { getInArr } from '@/helpers/getInArr'
import { billingConversionPrice } from '@/helpers/billingConversion'
import Row from '@UI/Row'
import { InputNew } from '../../../UI/InputNew'
import { Alert, DatePicker, Select, Space, Switch, Tooltip } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons'
import SelectNew from '@UI/New/Select'
import { CheckBoxLabel } from '@UI/CheckBox'
import Textarea from '../../../UI/Textarea'
import dayjs from 'dayjs'
import { useAddAlert } from '@/hooks/useAddAlert'
import { useConfirm } from '@/hooks/useConfirm'
import classNames from 'classnames'
import CreateGroupModal from '@pages/Admin/Manage/tabs/GroupsPage/components/CreateGroupModal/CreateGroupModal'
import SelectField from '@pages/Admin/CourseSettings/components/SelectField/SelectField'
import CheckboxLabel from '@pages/Admin/CourseSettings/components/CheckboxLabel/CheckboxLabel'
import { declOfNum } from '@/helpers/declOfNum'
import { closePreloader, openPreloader } from '@store/preloaderSlice'
import { notEnoughFreeSeatsInGroup } from '@/helpers/new/notEnoughFreeSeatsInGroup'
import { compareOptionsByLabel } from '@/helpers/new/compareOptionsByLabel'
import { useApiSearch } from '@/hooks/useApiSearch'
import Text from '@UI/New/Text'
import rolesEnum from '@/constant/rolesEnum'
import PrivateSchedulePlanner, {
  buildPrivateScheduleLessonData,
  getPrivateLessonLinkFromSeminarian,
  hasPrivateScheduleDays,
  hasPrivateScheduleInvalidDates,
  hasPrivateScheduleDaysWithoutTime,
  hasPrivateScheduleEqualTimes,
} from '@common/PrivateSchedulePlanner'
import TooltipWrapper from '@pages/Admin/CourseSettings/components/TooltipWrapper/TooltipWrapper'
import NewTooltipWrapper from '@UI/New/TooltipWrapper/TooltipWrapper'
import TextField from '@pages/Admin/CourseSettings/components/TextField/TextField'
import { normalizeNumberInput } from '@pages/Admin/CourseSettings/components/BasicTextField/helper'
import AddContractForm from '@pages/Admin/AllUsers/modals/AddContractModal/AddContractForm'
import sharedModalClasses from '@modals/index.module.css'
import { WorkHoursEditor } from '@common/WorkHours'
import { useTimetableConflicts } from '@/hooks/useTimetableConflicts'
import { getApiErrorMessage } from '@/helpers/getApiErrorMessage'
import { isDemoAvailableForTariffType } from '@/helpers/courseIndicators'

const defaultManualPaymentTypes = ['Оплата наличными', 'Оплата по счету']

const MIN_DELETE_PRELOADER_DELAY = 1500
const ADDITIONAL_TEACHERS_TOOLTIP =
  'Если вы включите данный тумблер, вы сможете добавить любого педагога в качестве дополнительного к этому ученику в рамках индивидуальных занятий по данному тарифу. У дополнительного педагога будут появляться все те же домашние работы, контрольные и пробники, которые задал основной педагог. Дополнительные педагоги смогут проверять эти работы, а также задавать собственные работы этому учащемуся. Смогут проводить индивидуальные занятия с этим учащимся, если вы поставите их в расписании'

const waitMinDeletePreloaderDelay = () =>
  new Promise((resolve) => setTimeout(resolve, MIN_DELETE_PRELOADER_DELAY))

const parseManualPaymentTypes = (value) => {
  if (!value) return defaultManualPaymentTypes
  try {
    const parsed = JSON.parse(value)
    if (!Array.isArray(parsed)) return defaultManualPaymentTypes
    const values = parsed
      .map((item) => (typeof item === 'string' ? item : item?.name))
      .map((item) => String(item ?? '').trim())
      .filter(Boolean)
    return [...new Set(values)]
  } catch (e) {
    return defaultManualPaymentTypes
  }
}

const transferPaymentTooltip = (
  <div className={s.transferPaymentTooltip}>
    <p>Что происходит при смене одного платного класса на другой?</p>
    <p>Процесс выглядит следующим образом:</p>
    <ol>
      <li>Предыдущий класс удаляется.</li>
      <li>Учащемуся добавляется новый класс.</li>
      <li>
        Система смотрит, до какого числа был оплачен предыдущий класс, и
        продлевает новый класс до того же периода.
      </li>
    </ol>
    <p>
      При этом в отчете по оплатам платежи по старому классу, которые относятся
      к будущим периодам, переносятся на оплату нового класса.
    </p>
    <p>
      Например, если сегодня 10 октября, а класс оплачен до 1 декабря, платеж с
      1 октября по 1 ноября разбивается: часть с 1 по 10 октября остается за
      старым классом, а часть с 11 по 30 октября переносится на новый. Все
      последующие будущие платежи полностью переходят на новый класс.
    </p>
    <p>
      Фактически система меняет назначение этих платежей: в платежке
      проставляется новый класс вместо старого.
    </p>
  </div>
)

export const BodyModal = ({ type, ...props }) => {
  const list = {
    Name,
    Ava,
    AddPost,
    RemovePost,
    AddContract,
    AddWorkHours,
    RemoveContract,
    RemoveDocument,
    RemoveChildren,
    Return,
    Dismiss,
    Password,
    ChangePassword,
    RecoverPassword,
    AddDirection,
    AddClass,
    AddGroupToClass,
    PasswordChanged,
    RemoveDirection,
    AddSeminarianDirection,
    RemoveSeminarianDirection,
  }
  const Component = list[type] ?? <></>
  return <Component {...props} />
}

const Name = (props) => {
  const [errorsList, setErrorsList] = React.useState([])
  const [showErrors, setShowErrors] = React.useState(false)
  const [name, setName] = React.useState(props.state.name)
  const [bindName] = useInputNew({
    name: 'full_name',
    value: name,
    onChange: setName,
    onError: setErrorsList,
    placeholder: 'Фамилия Имя отчество',
    validate: showErrors,
    // typeValid: 'name',
    errorText: 'Заполните ФИО через пробел',
  })

  const save = () => {
    setShowErrors(true)
    if (errorsList.valid) {
      props.setState(update(props.state, { name: { $set: name } }))
      props.close()
    }
  }

  return (
    <>
      <h2 className="modal__title">Редактировать ФИО</h2>
      <div className={s.body}>
        <Input.InputNew className={s.input} {...bindName} />
      </div>
      <div className={s.footerBtn}>
        <Button name="Изменить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const Ava = (props) => {
  const [file, setFile] = React.useState(props.state?.avatar_path ?? false)
  const [loading, setLoading] = React.useState(false)

  const [bindFile] = useInputNew({
    name: 'file',
    value: file,
    onChange: setFile,
    placeholder: 'Выберите файл',
    accept: '.jpg, .jpeg, .png, .svg, .gif',
  })

  const save = () => {
    setLoading(true)
    const data = new FormData()
    if (typeof file === 'object' && file !== null)
      data.append('avatar_path', file)
    else props.close()

    usersAPI.updAvatar({ id: props.state.id, data }).then((res) => {
      setLoading(false)
      const img = res?.data?.avatar_path
      if (img) {
        props.setState(update(props.state, { avatar_path: { $set: img } }))
        props.close()
      }
    })
  }

  const del = () => {
    props.setState(update(props.state, { avatar_path: { $set: false } }))
    props.close()
  }

  return (
    <>
      <h2 className="modal__title">Редактировать фото профиля</h2>
      <div className={s.body}>
        <div className={cn('ava', s.ava)}>
          <img
            src={
              typeof file === 'object'
                ? URL?.createObjectURL(file)
                : getAvatar({ avatar_path: file })
            }
            alt=""
          />
        </div>
        <Input.InputFile className={s.input} {...bindFile} />
      </div>
      <div className={s.footerBtn}>
        <Button
          name={loading ? 'Загрузка...' : 'Сохранить'}
          disable={loading}
          styles="yellow"
          action={save}
        />
        <Button name="Удалить" styles="red" disable={loading} action={del} />
      </div>
    </>
  )
}

const AddPost = (props) => {
  const [role, setRole] = React.useState('')
  const [bindSelect] = useInputNew({
    name: 'thematic',
    value: role,
    onChange: setRole,
    placeholder: 'Выберите роль',
    options: useSelector(getRolesSD).filter((i) => {
      if (i.value === 'children') return false
      if (getInArr(i.value, props?.data?.rolesName)) return false
      return true
    }),
  })

  // const { state: directionList, getState: getDirectionList } = useLoad({
  //   api: directionAPI.getAll,
  //   initState: [],
  //   key: 'data',
  //   last: false
  // })

  // React.useEffect(() => { if (role === 'seminarian') getDirectionList() }, [role])

  // const [direction, setDirection] = React.useState('')
  // const [bindDirection] = useInputNew({
  //   name: 'direction',
  //   value: direction,
  //   onChange: setDirection,
  //   placeholder: 'Выберите направление',
  //   title: 'Направление',
  //   errorText: 'Не выбрано направление',
  //   options: directionList?.map(({ id: value, name: label }) => ({ label, value })),
  //   style: { width: "100%" }
  // })

  const save = () => {
    if (role) {
      const roles = props.state.roles
      roles.push({
        item_name: role,
      })

      usersAPI
        .updateRoles({
          id: props.state.id,
          data: { roles },
        })
        .then((res) => {
          if (res.data.status === 'success') {
            // props.setState(
            //     update(props.state, { roles: { $push: [{ item_name: role }] } })
            // );

            props.addAlert({ title: 'Роль успешно добавлена' })
            props.close()
          }
        })
    } else {
      props.addAlert({ type: 'error', title: 'Не выбрана роль' })
    }
  }

  return (
    <>
      <h2 className="modal__title">Добавить должность</h2>
      <div className={s.body}>
        <Input.InputSelect className={s.input} {...bindSelect} />
        {/* {role === 'seminarian' && <Input.InputSelect {...bindDirection} />} */}
      </div>
      <div className={s.footerBtn}>
        <Button name="Добавить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RemovePost = (props) => {
  const save = () => {
    props.setState(
      update(props.state, { roles: { $splice: [[props.data, 1]] } }),
    )
    props.close()
  }
  return (
    <>
      <h2 className="modal__title">Удаление должность</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const AddSeminarianDirection = (props) => {
  const settings = useSelector((store) => store.settings)
  const allowSameCourseInDifferentGroups =
    settings?.allowStudentToEnrollSameCourseInDifferentGroups === '1'

  const getParams = () => {
    if (
      !allowSameCourseInDifferentGroups &&
      props?.state?.seminarianDirection?.length
    ) {
      return {
        filter: [
          `[direction_id][nin][]=${props?.state?.seminarianDirection?.map(
            ({ id }) => id,
          )}`,
        ],
      }
    }
    return
  }

  const { state: directionList } = useLoad({
    api: directionAPI.getAll,
    params: { ...getParams() },
    initState: [],
    key: 'data',
  })

  const [direction, setDirection] = React.useState('')
  const [bindDirection] = useInputNew({
    name: 'direction',
    value: direction,
    onChange: setDirection,
    placeholder: 'Выберите направление',
    title: 'Направление',
    errorText: 'Не выбрано направление',
    options: directionList?.map(({ id: value, name: label }) => ({
      label,
      value,
    })),
    style: { width: '100%' },
  })

  const save = () => {
    if (direction) {
      usersAPI
        .addDirection({
          data: { direction_id: direction, seminarian_id: props.state.id },
        })
        .then((res) => {
          if (res.data.status === 'success') {
            props.setState((prev) => ({
              ...prev,
              seminarianDirection: [
                ...prev.seminarianDirection,
                {
                  linkId: res.data.data.id,
                  id: direction,
                  name: directionList?.find((el) => el.id === direction)?.name,
                },
              ],
            }))
            props.addAlert({ title: 'Направление успешно добавлено' })
            props.close()
          }
        })
    } else {
      props.addAlert({ type: 'error', title: 'Не выбрано направление' })
    }
  }

  return (
    <>
      <h2 className="modal__title">Добавить направление</h2>
      <div className={s.body}>
        <Input.InputSelect {...bindDirection} />
      </div>
      <div className={s.footerBtn}>
        <Button name="Добавить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RemoveSeminarianDirection = (props) => {
  const save = () => {
    if (props.data) {
      usersAPI.removeDirection({ id: props.data }).then((res) => {
        if (res.data.status === 'success') {
          afterSave()
        }
      })
    } else {
      afterSave()
    }
  }

  const saveEnter = (e) => {
    if (e.key === 'Enter') {
      save()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', saveEnter)
    return () => {
      document.removeEventListener('keydown', saveEnter)
    }
  }, [])

  const afterSave = () => {
    props.setState((prev) => ({
      ...prev,
      seminarianDirection: prev.seminarianDirection.filter(
        (el) => el.linkId !== props.data,
      ),
    }))

    props.addAlert({ title: 'Направление успешно удалено' })
    props.close()
  }

  return (
    <>
      <h2 className="modal__title">Удаление направления</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const AddContract = (props) => {
  return (
    <>
      <div className={sharedModalClasses.modalHeader}>
        <div className={sharedModalClasses.modalTitleContainer}>
          <span className={sharedModalClasses.modalHeaderBigTitle}>
            Добавить договор
          </span>
        </div>
      </div>
      <AddContractForm
        state={props.state}
        setState={props.setState}
        close={props.close}
      />
    </>
  )
}

const RemoveContract = (props) => {
  const save = () => {
    usersAPI.removeContract({ id: props.data }).then((res) => {
      usersAPI
        .getUser({ id: props.state.id, expand: ['contracts'] })
        .then((res) =>
          props.setState(
            update(props.state, { contracts: { $set: res.data.contracts } }),
          ),
        )
      props.close()
    })
  }
  return (
    <>
      <h2 className="modal__title">Удалить договор</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const RemoveDocument = (props) => {
  const save = () => {
    supportAPI
      .cancel({
        params: { id: props.data },
        data: { executor_comment: 'Отклонено админом в карточке учащегося' },
      })
      .then((res) => {
        if (res.data.status === 'success') {
          usersAPI
            .getUser({ id: props.state.id, expand: ['documents'] })
            .then((res) =>
              props.setState(
                update(props.state, {
                  documents: { $set: res.data.documents },
                }),
              ),
            )
          props.close()
        }
      })
  }
  return (
    <>
      <h2 className="modal__title">Отклонить договор</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const RemoveChildren = (props) => {
  const save = () => {
    props.data.deleteChild(props.data.childrenId)
    props.close()
  }
  return (
    <>
      <h2 className="modal__title">Удалить ребенка из списка детей родителя</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Подтвердить действие" styles="red" action={save} />
      </div>
    </>
  )
}

const Return = (props) => {
  //   const save = () => {
  //     props.close()
  //   }
  //   return <>
  //     <h2 className='modal__title'>Восстановить коллегу</h2>
  //     <div className={s.body}>
  //     </div>
  //     <div className={s.footerBtn}>
  //       <Button name='Подтвердить действие' styles='yellow' action={save} />
  //     </div>
  //   </>
}
const Dismiss = (props) => {
  //   const save = () => {
  //     props.close()
  //   }
  //   return <>
  //     <h2 className='modal__title'>Уволить коллегу</h2>
  //     <div className={s.body}>
  //     </div>
  //     <div className={s.footerBtn}>
  //       <Button name='Подтвердить действие' styles='red' action={save} />
  //     </div>
  //   </>
}

const toNumberWithDot = (text) => {
  let value = text.replace(/[^0-9.]/g, '')
  value = value.replace(/([.].*)[.]/g, '$1')
  value = value.replace(/^([.])/, '')

  return value
}

const addHttpsToLessonLink = (value, previousValue = '') => {
  if (!value || /^https?:\/\//i.test(value)) return value
  const isProtocolDraft = ['http://', 'https://'].some((protocol) =>
    protocol.startsWith(value.toLowerCase()),
  )

  if (
    previousValue &&
    previousValue.length <= 'https://'.length &&
    isProtocolDraft
  ) {
    return value
  }

  return `https://${value}`
}

const AddDirection = (props) => {
  const addAlert = useAddAlert()
  const { confirmRequest, conflictsModal } = useTimetableConflicts()
  const showConfirm = useConfirm()
  const dateFormat = 'YYYY.MM.DD'
  const methodPUT = !!props?.data?.item?.privateInfo?.id
  const [initialGroupId] = useState(
    () => props?.data?.item?.group_id ?? props?.data?.item?.group?.id ?? null,
  )

  const directionIds = props?.data?.directions ?? []
  const settings = useSelector((store) => store.settings)
  const isUniversalBalance = settings?.isUniversalBalance === '1'
  const allowSameCourseInDifferentGroups =
    settings?.allowStudentToEnrollSameCourseInDifferentGroups === '1'
  const [tariffType, setTariffType] = useState()
  const [demoAccess, setDemoAccess] = useState(false)
  const [demoPeriodStart, setDemoPeriodStart] = useState(dayjs())
  const [demoPeriodEnd, setDemoPeriodEnd] = useState(dayjs().add(6, 'day'))
  const [recalculatePast, setRecalculatePast] = useState(false)
  const [recalculateFrom, setRecalculateFrom] = useState(null)
  const [lessonDates, setLessonDates] = useState([])
  const [loadingLessonDates, setLoadingLessonDates] = useState(false)
  const [lessonDatesFailed, setLessonDatesFailed] = useState(false)
  const [groupSelectionChanged, setGroupSelectionChanged] = useState(false)
  const [process, setProcess] = useState(() => false)
  const [privateSchedule, setPrivateSchedule] = useState({})
  const [courses, setCourses] = React.useState(
    props?.data?.item ? [props.data.item] : [],
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    directionAPI
      .getAll({
        student_id: props.state.id,
        filter:
          !allowSameCourseInDifferentGroups && directionIds?.length > 0
            ? [`[direction_id][nin][]=${directionIds}`]
            : [],
        expand: [
          'directionTariffs.tariffPeriods',
          'directionTariffs.tariffWeeks',
          'directionTariffs.tariffDays',
          'teacher',
        ],
      })
      .then((res) => setCourses(res?.data?.data))
  }, [])

  const initState = {
    direction: props?.data?.item?.direction_id ?? undefined,
    tariff: props?.data?.item?.tariff_id ?? '',
    sum: isUniversalBalance
      ? 0
      : props?.data?.item?.private_balance ??
        props?.data?.item?.payment_amount ??
        '',
    buyHours: isUniversalBalance ? 0 : props?.data?.item?.buy_hours ?? '',
    salaryPerHour: props?.data?.item?.privateInfo?.salary_per_hour ?? '',
    hourCost: props?.data?.item?.privateInfo?.hour_cost ?? '',
    // timeOneLesson: props?.data?.item?.privateInfo?.time_one_lesson
    //   ? Math.ceil(
    //       parseFloat(
    //         props?.data?.item?.privateInfo?.time_one_lesson?.toFixed(2),
    //       ),
    //     ) ?? ''
    //   : '',
    teacherId: props?.data?.item?.teacher_id ?? '',
    // buyMonths: isUniversalBalance ? 0 : props?.data?.item?.buy_months ?? "",
    paidFromForDerection: String(dayjs().format(dateFormat)),
    newPaymentForDerection: false,
    paidFromDateForDerection: dayjs(),
    paidBeforeForDerection: null,
    paidBeforeDateForDerection: null,
    // currency: props?.data?.item?.privateInfo?.currency ?? 'rub',
    file: '',
    group_id: initialGroupId,
    defaultDuration: props?.data?.item?.privateInfo?.default_duration ?? 60,
    privateLessonLink: '',
    hasAdditionalTeachers:
      (props?.data?.item?.additionalTeachers ?? []).length > 0,
    additionalTeacherIds:
      props?.data?.item?.additionalTeachers?.map((teacher) => teacher.id) ?? [],
  }

  const onChangePaidBeforeDateForDerection = (date, dateString) => {
    setState((prevState) => ({
      ...prevState,
      paidBeforeForDerection: dateString,
      paidBeforeDateForDerection: date,
    }))
  }
  const onChangePaidFromDateForDerection = (date, dateString) => {
    setState((prevState) => ({
      ...prevState,
      paidFromForDerection: dateString,
      paidFromDateForDerection: date,
    }))
  }

  const [state, setState] = React.useState(initState)
  const lessonDateSet = useMemo(
    () => new Set(
      (Array.isArray(lessonDates) ? lessonDates : [])
        .map((date) => String(date ?? '').match(/^\d{4}-\d{2}-\d{2}/)?.[0])
        .filter(Boolean),
    ),
    [lessonDates],
  )
  const renderLessonDate = useCallback((date) => (
    <div
      className={classNames('ant-picker-cell-inner', {
        [s.lessonDate]: lessonDateSet.has(date.format('YYYY-MM-DD')),
      })}
    >
      {date.date()}
    </div>
  ), [lessonDateSet])
  const withoutTeacher = methodPUT && ['hour', 'minute'].includes(tariffType) && !state.teacherId
  const lessonPriceChanged =
    methodPUT &&
    ['group_per_lesson', 'hour', 'minute'].includes(tariffType) &&
    Number.isFinite(Number(state.hourCost)) &&
    Number(state.hourCost) !== Number(props?.data?.item?.privateInfo?.hour_cost)
  const shouldRecalculatePast = lessonPriceChanged && recalculatePast
  const isGroupLessonPaymentGroupChanged =
    methodPUT &&
    tariffType === 'group_per_lesson' &&
    groupSelectionChanged

  useEffect(() => {
    if (lessonPriceChanged) return
    setRecalculatePast(false)
    setRecalculateFrom(null)
  }, [lessonPriceChanged])

  useEffect(() => {
    if (!shouldRecalculatePast) return
    let active = true
    setLoadingLessonDates(true)
    setLessonDatesFailed(false)
    directionOrdersApi.groupLessonPriceDates(props.data.item.id)
      .then(({ data }) => {
        if (active) {
          if (data?.status !== 'success') throw new Error('Не удалось загрузить даты занятий')
          setLessonDates(data?.data?.dates ?? [])
        }
      })
      .catch(() => {
        if (active) {
          setLessonDatesFailed(true)
          addAlert({ type: 'error', title: 'Не удалось загрузить даты проведенных занятий' })
        }
      })
      .finally(() => { if (active) setLoadingLessonDates(false) })
    return () => { active = false }
  }, [shouldRecalculatePast, props.data.item?.id, addAlert])

  const isManualPaymentTypeSelectionEnabled = useSelector(
    (store) => store.settings.isManualPaymentTypeSelectionEnabled === '1',
  )
  const isSeparateLinksForStudentsAndTeachers = useSelector(
    (store) => store.settings.isSeparateLinksForStudentsAndTeachers === '1',
  )
  const manualPaymentTypes = parseManualPaymentTypes(
    useSelector((store) => store.settings.custom.manualPaymentTypes),
  )
  const [manualPaymentType, setManualPaymentType] = useState(null)
  const GROUP_TARIFF_TYPES = [
    'month',
    'stream_custom_days',
    'stream_custom_period',
    'stream_custom_weeks',
    'stream_one_time',
  ]
  const selectedDirectionOrders = useMemo(() => {
    return (props?.data?.orders ?? []).filter((item) => {
      if (Number(item?.direction_id) !== Number(state.direction)) return false
      if (
        props?.data?.item?.id &&
        Number(item?.id) === Number(props?.data?.item?.id)
      ) {
        return false
      }
      return true
    })
  }, [props?.data?.orders, props?.data?.item?.id, state.direction])

  const occupiedGroupIds = useMemo(
    () =>
      selectedDirectionOrders
        .map((item) => Number(item?.group_id))
        .filter((item) => !!item),
    [selectedDirectionOrders],
  )

  const tariffs = courses?.find(
    (i) => i.id === state.direction,
  )?.directionTariffs

  const getSelectedTariff = () =>
    tariffs?.find((tariff) => tariff.id === state.tariff)

  const [curseGroups, setCourseGroups] = useState([])
  const [attachedGroup, setAttachedGroup] = useState(null)
  const [createGroupModal, setCreateGroupModal] = useState(false)
  const selectedGroup = useMemo(
    () => curseGroups?.find((group) => group.value === state.group_id),
    [curseGroups, state.group_id],
  )
  const groupOptions = useMemo(
    () =>
      tariffType === 'group_per_lesson'
        ? curseGroups?.filter((group) => group.type === 'lesson-payment')
        : curseGroups,
    [curseGroups, tariffType],
  )

  const fetchGrups = () => {
    if (!state.direction) return
    directionGroupApi
      .get({
        filter: [`[direction_id][eq]=${state.direction}`],
        expand: ['teacher'],
        student_id: props.state.id,
      })
      .then((res) => {
        setCourseGroups(
          res.data
            ?.map(
              ({
                name,
                id: value,
                teacher,
                max_students,
                student_count,
                type,
                lesson_duration,
                student_lesson_price,
                is_shared_balance,
                shared_balance,
              }) => {
                const crowded = notEnoughFreeSeatsInGroup({
                  g: {
                    max_students,
                    student_count,
                  },
                  parameterForComparison: 1,
                })
                const sharedBalanceUnavailable =
                  methodPUT &&
                  tariffType === 'group_per_lesson' &&
                  is_shared_balance &&
                  Number(value) !== Number(props.data.item?.group_id)
                const unavailableReason = [
                  crowded ? 'нет мест' : '',
                  sharedBalanceUnavailable ? 'общий баланс' : '',
                ]
                  .filter(Boolean)
                  .join(', ')

                return {
                  label: `${name} - ${formateName(teacher?.name, 'F I')}${
                    unavailableReason ? ` (${unavailableReason})` : ''
                  }`,
                  value,
                  max_students,
                  student_count,
                  type,
                  lesson_duration,
                  student_lesson_price,
                  is_shared_balance,
                  shared_balance,
                  disabled: crowded,
                }
              },
            )
            ?.filter(
              (group) => !occupiedGroupIds.includes(Number(group?.value)),
            ),
        )
      })
  }

  const onGroupCreated = () => {
    setCreateGroupModal(false)
    fetchGrups()
  }

  React.useEffect(() => {
    fetchGrups()
  }, [state.direction, occupiedGroupIds])

  const findTariffType = React.useCallback(() => {
    if (props?.data?.item?.tariff_id)
      return props.data.item.direction.directionTariffs?.find(
        (i) => i.id === state.tariff,
      )?.type
    return tariffs?.find((i) => i.id === state.tariff)?.type
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.tariff])

  useEffect(() => {
    setTariffType(findTariffType())
  }, [findTariffType])

  const selectedTariff = getSelectedTariff()
  const isDemoAvailable =
    !methodPUT &&
    isDemoAvailableForTariffType(selectedTariff?.type ?? tariffType)
  const isDemoEnabled = isDemoAvailable && demoAccess

  useEffect(() => {
    if (!isDemoAvailable) {
      setDemoAccess(false)
      return
    }

    const demoDays = Math.max(Number(selectedTariff?.demo_days) || 7, 1)
    setDemoPeriodStart(dayjs())
    setDemoPeriodEnd(dayjs().add(demoDays - 1, 'day'))
  }, [isDemoAvailable, selectedTariff?.demo_days, selectedTariff?.id])

  const [bindTariff] = useInputNew({
    name: 'tariff',
    value: state.tariff,
    onChange: (e) => {
      const tariff = tariffs.find((t) => t.id === e)
      setState((prev) => ({
        ...initState,
        direction: prev.direction,
        hourCost: tariff?.first_price,
        defaultDuration: tariff?.lesson_duration ?? 60,
        tariff: e,
        newPaymentForDerection: tariff?.type !== 'free',
      }))
      const attachedGroup = curseGroups?.find(
        (item) => item?.value === tariff?.attached_groups,
      )
      setAttachedGroup(attachedGroup)
    },
    title: 'Тариф',
    placeholder: 'Выберите тариф',
    errorOptions: 'Выберите направление',
    options:
      tariffs
        ?.filter(
          (tariff) =>
            !selectedDirectionOrders.length ||
            GROUP_TARIFF_TYPES.includes(tariff?.type),
        )
        ?.map(({ name: label, id: value }) => ({ label, value })) ?? [],
  })

  const [bindGroup] = useInputNew({
    name: 'group',
    value: state.group_id,
    onChange: (e) => {
      if (attachedGroup) return
      setGroupSelectionChanged(String(e ?? '') !== String(initialGroupId ?? ''))
      setState((prev) => ({
        ...prev,
        group_id: e,
      }))
    },
    title: 'Группа',
    placeholder: 'Выберите группу',
    errorOptions: 'Выберите группу',
    options: curseGroups,
  })

  const [bindSum] = useInputNew({
    name: 'sum',
    value: state.sum,
    onChange: (e) => {
      if (!isUniversalBalance) {
        setState((prev) => ({ ...prev, sum: normalizeNumberInput({value:e}) }))
      }
    },
    title: selectedGroup?.is_shared_balance ? (
      <span className={s.labelWithInfo}>
        Баланс группы
        <Tooltip title="Вы выбрали группу у которой один баланс на всех учащихся, в поле ниже отображается текущий баланс этой группы, вы можете его изменить.">
          <InfoCircleOutlined className={s.infoIcon} />
        </Tooltip>
      </span>
    ) : isIndividualTariffType(tariffType) ? (
      'Сумма оплаты (введите баланс учащегося)'
    ) : (
      'Сумма оплаты'
    ),
    placeholder: isUniversalBalance
      ? 0
      : String(
          Number(
            tariffs?.find((i) => i.id === state.tariff)?.first_price ?? 1300,
          ) * 3,
        ),
  })

  const [bindFile] = useInputNew({
    name: 'document',
    value: state.file,
    onChange: (e) => setState((prev) => ({ ...prev, file: e })),
    placeholder: 'Прикрепить',
    title: 'Прикрепите подтверждающий документ',
  })

  const [bindDefaultDuration] = useInputNew({
    name: 'defaultDuration',
    value: state.defaultDuration,
    onChange: (e) => {
      setState((prev) => {
        const duration = parseFloat(e)

        return {
          ...prev,
          defaultDuration: isNaN(duration) ? null : duration,
        }
      })
    },
    title: (
      <span className={s.labelWithInfo}>
        Стандартная длительность занятия (минуты)
        <Tooltip title="Это планируемое количество занятий в неделю, которое влияет исключительно на аналитику проведения занятий">
          <InfoCircleOutlined className={s.infoIcon} />
        </Tooltip>
      </span>
    ),
    placeholder: 60,
  })

  const notSendRequest =
    !methodPUT && tariffType !== 'hour' && tariffType !== 'minute'

  const allEmployeesParams = useMemo(() => {
    return {
      'per-page': 1000,
      allEmployee: 1,
      withConferenceLinks: 1,
      student_id: props.state.id,
      ...(!!props?.data?.item?.direction_id
        ? { directionId: props?.data?.item?.direction_id }
        : {}),
    }
  }, [props?.data?.item?.direction_id, props.state.id, notSendRequest])

  const {
    data: allEmployees = [],
    loading: loadingAllEmployees,
    searchQuery: searchQueryAllEmployees,
    setSearchQuery: setSearchQueryAllEmployees,
  } = useApiSearch({
    apiMethod: usersAPI.getColleaguesForGroup,
    responseKey: 'data',
    searchKey: 'name',
    minQueryLength: 0,
    params: allEmployeesParams,
    notSendRequest,
  })

  const fieldsAllEmployees = {
    loading: loadingAllEmployees,
    showSearch: true,
    filterSort: (a, b) => a.value === '0' ? -1 : b.value === '0' ? 1 : compareOptionsByLabel(a, b),
    filterOption: false,
    onChange: (selectedSeminarianId) => {
      setState((prev) => {
        const selectedSeminarian = selectedSeminarianId
          ? allEmployees.find(
              (item) => Number(item.id) === Number(selectedSeminarianId),
            )
          : null

        const directionSelectedSeminarian =
          selectedSeminarian?.directions?.find(
            (el) => Number(el.id) === Number(state.direction),
          )

        const salaryPerHour = directionSelectedSeminarian?.rate ?? 0

        return {
          ...prev,
          teacherId: selectedSeminarianId ? Number(selectedSeminarianId) : '',
          privateLessonLink:
            getPrivateLessonLinkFromSeminarian(
              selectedSeminarian,
              isSeparateLinksForStudentsAndTeachers,
            ),
          salaryPerHour,
        }
      })
    },
    options: [
      ...(methodPUT ? [{ label: 'Без педагога', value: '0' }] : []),
      ...(allEmployees?.map((employee) => ({ label: employee.name, value: employee.id })) ?? []),
    ],
    value: state.teacherId ? String(state.teacherId) : methodPUT ? '0' : null,
    placeholder:
      !loadingAllEmployees && !allEmployees.length
        ? 'В данной франшизе нет педагогов'
        : 'Выберите учителя',
    onSearch: setSearchQueryAllEmployees,
    notFoundContent: 'В данной франшизе нет педагогов',
  }

  const selectedSeminarian = useMemo(() => {
    return state.teacherId
      ? allEmployees.find((item) => Number(item.id) === Number(state.teacherId))
      : null
  }, [allEmployees, state.teacherId])
  const additionalTeacherOptions = useMemo(
    () =>
      allEmployees
        .filter((employee) => Number(employee.id) !== Number(state.teacherId))
        .map((employee) => ({ label: employee.name, value: employee.id })),
    [allEmployees, state.teacherId],
  )

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (!methodPUT && (tariffType === 'hour' || tariffType === 'minute')) {
      usersAPI
        .prevDirectionOrder({
          user_id: props.state.id,
          direction_id: state.direction,
          tariff_id: state.tariff,
        })
        .then(({ data }) => {
          if (data) {
            const buyHours = parseFloat(data.buy_hours)

            setState((prev) => ({
              ...prev,
              buyHours: isNaN(buyHours) ? null : buyHours,
              // buyMonths: data.buy_months?.replace(/[^\d]/g, ""),
              sum: 0,
            }))
          }
        })
    }
  }, [tariffType])

  const [bindSalaryPerHour] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'payment_amount',
    onChange: (e) =>
      setState((prev) => ({
        ...prev,
        salaryPerHour: normalizeNumberInput({value: e}),
      })),
    placeholder: billingConversionPrice(
      Number(tariffs?.find((i) => i.id === state.tariff)?.first_price) - 300,
      tariffType,
    ),
    title: `ЗП педагога за занятие`,
    value: state.salaryPerHour,
  })

  const [bindHourCost] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'hour_cost',
    onChange: (e) =>
      setState((prev) => ({ ...prev, hourCost: normalizeNumberInput({value: e}) })),
    placeholder: billingConversionPrice(
      tariffs?.find((i) => i.id === state.tariff)?.first_price,
      tariffType,
    ),
    title: `Стоимость занятия для ребёнка`,
    value: state.hourCost,
  })

  const [bindPrivateLessonLink] = useInputNew({
    name: 'privateLessonLink',
    onChange: (value) =>
      setState((prev) => ({
        ...prev,
        privateLessonLink: addHttpsToLessonLink(value, prev.privateLessonLink),
      })),
    placeholder: 'https://example.com/teacher-room',
    title: 'Ссылка на занятие',
    value: state.privateLessonLink,
  })

  const [bindCurrency] = useInputNew({
    errorText: 'Поле не может быть пустым',
    name: 'currency',
    onChange: (e) => setState((prev) => ({ ...prev, currency: e })),
    options: [
      { label: '₽', value: 'rub' },
      { label: '$', value: 'dollar' },
      { label: '€', value: 'euro' },
    ],
    title: `Валюта`,
    value: state.currency,
  })

  // const [bindTimeOneLesson] = useInputNew({
  //   errorText: 'Поле не может быть пустым',
  //   name: 'time_one_lesson',
  //   onChange: (e) =>
  //     setState((prev) => ({
  //       ...prev,
  //       timeOneLesson: e.replace(/[^.\d]/g, ''),
  //     })),
  //   placeholder: billingConversion(1.5, { type: tariffType })
  //     ?.replaceWithAnAlternative,
  //   title: `Длительность / минут`,
  //   value: state.timeOneLesson,
  // })

  const save = async (_event, groupChangeConfirmed = false) => {
    if (process) {
      return
    }

    if (
      isDemoEnabled &&
      (!demoPeriodStart?.isValid?.() ||
        !demoPeriodEnd?.isValid?.() ||
        demoPeriodEnd.isBefore(demoPeriodStart, 'day'))
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Проверьте даты начала и окончания демо-периода',
      })
      return
    }

    if (
      !isDemoEnabled &&
      [
        'month',
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(tariffType) &&
      (state.paidFromForDerection == null ||
        state.paidFromForDerection?.length < 4 ||
        state.paidBeforeForDerection == null ||
        state.paidBeforeForDerection?.length < 4)
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Необходимо указать даты, с какого момента оплачено направление и до какого',
      })
      return
    }

    if (['minute', 'hour']?.includes(tariffType) && !withoutTeacher) {
      if (
        state.hasAdditionalTeachers &&
        state.additionalTeacherIds.length === 0
      ) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Выберите хотя бы одного дополнительного педагога',
        })
        return
      }
      if (!state.defaultDuration || state.defaultDuration < 0) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Необходимо указать стандартную длительность занятия',
        })
        return
      }

      if (state.defaultDuration < 1 || state.defaultDuration > 1440) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Стандартная длительность занятия не может быть меньше 1 минуты и больше 24 часов',
        })
        return
      }

      if (state.timeOneLesson < 1 || state.timeOneLesson > 1440) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Длительность занятия не может быть меньше 1 минуты и больше 24 часов',
        })
        return
      }

      if (
        shouldShowPrivateSchedule &&
        hasPrivateScheduleDays(privateSchedule) &&
        !state.teacherId
      ) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Чтобы добавить занятия в расписание, выберите педагога',
        })
        return
      }

      if (
        shouldShowPrivateSchedule &&
        hasPrivateScheduleDaysWithoutTime(privateSchedule)
      ) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Укажите время начала и окончания для каждого отмеченного дня',
        })
        return
      }

      if (
        shouldShowPrivateSchedule &&
        hasPrivateScheduleEqualTimes(privateSchedule)
      ) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Время начала и окончания не должны совпадать',
        })
        return
      }

      if (
        shouldShowPrivateSchedule &&
        hasPrivateScheduleInvalidDates(privateSchedule)
      ) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Проверьте даты начала и окончания занятий',
        })
        return
      }
    }
    if (
      !isDemoEnabled &&
      [
        'month',
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
      ]?.includes(tariffType) &&
      Number(state.paidFromForDerection.replace(/\./gi, '')) >
        Number(state.paidBeforeForDerection.replace(/\./gi, ''))
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Дата до которой оплачено направление не может быть меньше даты оплаты',
      })
      return
    }
    if (
      [
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
        'free',
        'month',
        'stream_one_time',
        'group_per_lesson',
      ]?.includes(tariffType)
    ) {
      if ((state?.group_id === null || state?.group_id === undefined) && !(methodPUT && tariffType === 'group_per_lesson')) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Нужно обязательно выбрать группу',
        })
        return
      }

      const group = curseGroups?.find((el) => el.value === state.group_id)
      if (!!group?.max_students && !!group?.student_count && !attachedGroup && (!methodPUT || Number(state.group_id) !== Number(props.data.item?.group_id))) {
        if (Number(group?.student_count) >= Number(group?.max_students)) {
          addAlert({
            type: 'error',
            title: 'Ошибка',
            text: 'В выбранную группу нельзя добавить учащегося, она переполнена',
          })
          return
        }
      }
    }

    if (shouldRecalculatePast && (!recalculateFrom || loadingLessonDates || lessonDatesFailed)) {
      addAlert({ type: 'error', title: 'Выберите дату начала перерасчета после загрузки дат занятий' })
      return
    }

    if (isGroupLessonPaymentGroupChanged && !groupChangeConfirmed) {
      showConfirm({
        variant: 'compact',
        title: 'Вы точно хотите поменять группу?',
        text: 'При смене группы у учащегося будут удалены все занятия из предыдущей группы, по которым у него нет отчёта. Все занятия, по которым отчёт уже есть, останутся у учащегося.',
        confirmText: 'Сменить',
        cancelText: 'Отмена',
        disableBackdropDismiss: true,
        onConfirm: () => save(null, true),
      })
      return
    }

    const data = new FormData()
    data.append('children_id', props.state.id)
    data.append('direction_id', state.direction)
    data.append('tariff_id', state.tariff)
    data.append('payment_amount', isDemoEnabled ? '0' : state.sum)
    data.append('status', 1)
    data.append('demo_access', String(isDemoEnabled))
    if (manualPaymentType) {
      data.append('manual_payment_type', manualPaymentType)
    }

    if (state?.group_id) {
      data.append('group_id', state.group_id)
    }

    if (tariffType === 'group_per_lesson') {
      const lessonPriceNumber = Number(state.hourCost)
      data.append(
        'student_lesson_price',
        String(
          Number.isFinite(lessonPriceNumber) && lessonPriceNumber >= 0
            ? lessonPriceNumber
            : 0,
        ),
      )
    }

    if (
      [
        'month',
        'stream_custom_period',
        'stream_custom_days',
        'stream_custom_weeks',
        'stream_one_time',
        'group_per_lesson',
      ]?.includes(tariffType)
    ) {
      if (isDemoEnabled) {
        data.append(
          'demo_started_at',
          demoPeriodStart.startOf('day').format(),
        )
        data.append('demo_ends_at', demoPeriodEnd.endOf('day').format())
        data.append('status_payment', 'false')
        data.append('new_payment', 'false')
      } else {
        if (tariffType !== 'stream_one_time') {
          data.append('paid_from', state.paidFromForDerection)
          data.append('next_payment_date', state.paidBeforeForDerection)
        }
        data.append('new_payment', state.newPaymentForDerection)
      }
    }
    if (tariffType === 'hour' || tariffType === 'minute') {
      data.append('new_payment', state.newPaymentForDerection)
      data.append('default_duration', state.defaultDuration)
      data.append('buy_hours', calculateBuyHoursFromBalance())
      data.append('salary_per_hour', state.salaryPerHour ?? 0)
      data.append('hour_cost', state.hourCost ?? 0)
      data.append(
        'additional_teacher_ids',
        JSON.stringify(
          state.hasAdditionalTeachers ? state.additionalTeacherIds : [],
        ),
      )
    }

    if (
      (state.buyHours || state.buyHours === 0) &&
      !(tariffType === 'hour' || tariffType === 'minute')
    ) {
      data.append('buy_hours', state.buyHours)
      data.append('salary_per_hour', state.salaryPerHour ?? 0)
      data.append('hour_cost', state.hourCost ?? 0)
      // data.append(
      //   'time_one_lesson',
      //   billingConversion(state.timeOneLesson, { type: tariffType })
      //     .fractionalExpression ?? 0,
      // )
      // data.append('currency', state.currency ?? 'rub')
    }

    state.teacherId && data.append('teacher_id', state.teacherId)

    // if (state.buyMonths || state.buyMonths === 0) {
    //   data.append("buy_months", state.buyMonths);
    // }

    if (typeof state.file === 'object') data.append('document', state.file)

    if (tariffType === 'free') {
      data.append('buy_months', 0)
      data.append('payment_amount', 0)
    }

    const updData = withoutTeacher ? { teacher_id: null } : {
      hour_cost: state.hourCost,
      salary_per_hour: state.salaryPerHour,
      // time_one_lesson: billingConversion(state.timeOneLesson, {
      //   type: tariffType,
      // }).fractionalExpression,
      // currency: state.currency,
      teacher_id: state.teacherId,
      ...(tariffType === 'group_per_lesson'
        ? {
            first_price:
              Number.isFinite(Number(state.hourCost)) &&
              Number(state.hourCost) >= 0
                ? Number(state.hourCost)
                : 0,
            group_id: state.group_id || null,
          }
        : {}),
      ...(['hour', 'minute'].includes(tariffType)
        ? {
            default_duration: state.defaultDuration,
          }
        : {}),
      ...(shouldRecalculatePast
        ? { recalculate_from: recalculateFrom.format('YYYY-MM-DD') }
        : {}),
    }

    setProcess(true)

    if (methodPUT) {
      directionOrdersApi
        .updPrivateInfo({
          data: updData,
          params: { id: props.data.item.privateInfo.id },
        })
        .then(async (res) => {
          if (res?.data?.status === 'success') {
            if (tariffType !== 'group_per_lesson' && !withoutTeacher) await directionOrdersApi.updAdditionalTeachers({
              id: props.data.item.id,
              additional_teacher_ids: state.hasAdditionalTeachers
                ? state.additionalTeacherIds
                : [],
            })
            props.getDirection()
            props.close()
            addAlert({
              title: 'Курс обновлен!',
            })
          }
        })
        .catch(() => {})
        .finally(() => setProcess(false))
    } else {
      const lessonData = getPrivateScheduleLessonData(props.state.id)
      let checkedSchedule
      if (lessonData) {
        try {
          checkedSchedule = await confirmRequest(
            () => timetableBeta.checkConflicts({ data: lessonData }),
            { checkOnly: true },
          )
          if (!checkedSchedule) {
            setProcess(false)
            return
          }
        } catch (error) {
          addAlert({ title: 'Не удалось проверить расписание', text: getApiErrorMessage(error), type: 'error' })
          setProcess(false)
          return
        }
      }
      directionOrdersApi
        .createOrder({ data })
        .then(async (res) => {
          if (res?.data?.status === 'success') {
            let scheduleNotCreated = false
            if (lessonData) {
              try {
                const result = await confirmRequest((hash) => timetableBeta.addLesson({ data: {
                  ...lessonData,
                  ...(hash && { confirmed_conflicts_hash: hash }),
                } }, { skipGlobalErrorAlert: true }), { confirmedHash: checkedSchedule?.confirmedHash })
                if (!result) {
                  scheduleNotCreated = true
                  addAlert({ title: 'Ученик и тариф сохранены, занятия не созданы', type: 'warning' })
                }
              } catch (error) {
                scheduleNotCreated = true
                addAlert({
                  title: 'Курс добавлен, но занятия не созданы',
                  text: getApiErrorMessage(error),
                  type: 'error',
                })
              }
            }
            props.getDirection()
            props.close()
            if (!scheduleNotCreated) addAlert({
              title: 'Курс добавлен!',
            })
          }
        })
        .finally(() => setProcess(false))
    }
  }

  const showIsNewPay = getSelectedTariff()?.name !== 'Индивидуальный'

  function calculateBuyHoursFromBalance() {
    const balance = Number(state.sum ?? 0)
    const price = Number(
      state.hourCost || getSelectedTariff()?.first_price || 0,
    )

    if (!price) return 0

    return Number((balance / price).toFixed(2))
  }

  function isIndividualTariffType(type) {
    return ['hour', 'minute', 'group_per_lesson'].includes(type)
  }

  useEffect(() => {
    if (!attachedGroup?.value) return
    setState((prev) => ({
      ...prev,
      group_id: attachedGroup?.value,
      sum: attachedGroup?.is_shared_balance
        ? attachedGroup?.shared_balance ?? 0
        : prev.sum,
    }))
  }, [attachedGroup])

  const filterSort = useCallback((optionA, optionB) => {
    return (optionA?.label ?? '')
      .toLowerCase()
      .localeCompare((optionB?.label ?? '').toLowerCase())
  }, [])

  const isIndividual = ['hour', 'minute'].includes(tariffType)
  const shouldShowPrivateSchedule =
    !methodPUT && isIndividual && !getSelectedTariff()?.any_seminarian

  useEffect(() => {
    props.setBodyModal?.((prev) => {
      if (prev?.type !== 'AddDirection' || prev?.disableClose === process) {
        return prev
      }

      return {
        ...prev,
        disableClose: process,
      }
    })
  }, [process, props])

  const getPrivateScheduleLessonData = (childrenId) => {
    if (
      !shouldShowPrivateSchedule ||
      !hasPrivateScheduleDays(privateSchedule)
    ) {
      return
    }

    const selectedSeminarian = state.teacherId
      ? allEmployees.find((item) => Number(item.id) === Number(state.teacherId))
      : null
    const teacherLessonLink = getPrivateLessonLinkFromSeminarian(
      selectedSeminarian,
    )

    return buildPrivateScheduleLessonData({
      schedule: privateSchedule,
      durationMinutes: state.defaultDuration,
      directionId: state.direction,
      teacherId: state.teacherId,
      childrenId,
      linkToMeeting: isSeparateLinksForStudentsAndTeachers
        ? teacherLessonLink
        : state.privateLessonLink,
      linkToMeetingForChildren: isSeparateLinksForStudentsAndTeachers
        ? state.privateLessonLink
        : undefined,
    })
  }

  const title = methodPUT
    ? tariffType === 'group_per_lesson'
      ? 'Изменить данные по тарифу у учащегося'
      : 'Редактирование частного курса'
    : 'Добавить курс'

  return (
    <>
      <h2 className="modal__title">{title}</h2>
      <div className={s.bodyNew}>
        {!methodPUT && (
          //<Input.InputSelect className={s.input} {...bindDirection} />
          <div className={s.selectWithLabel}>
            <div className={s.selectLabel}>Курс</div>
            <Select
              showSearch
              className={classNames(
                s.select,
                s.removeBoxShadow,
                s.customSelect,
              )}
              placeholder="Выберите курс"
              optionFilterProp="label"
              value={state.direction}
              onChange={(e) => setState({ ...initState, direction: e })}
              filterSort={filterSort}
              options={courses?.map(({ name: label, id: value }) => ({
                label,
                value,
              }))}
            />
          </div>
        )}
        {!methodPUT && (
          <div className={s.selectWithLabel}>
            <div className={s.selectLabel}>Тариф</div>
            <Select
              showSearch
              className={classNames(
                s.select,
                s.removeBoxShadow,
                s.customSelect,
              )}
              placeholder="Выберите тариф"
              optionFilterProp="label"
              value={state.tariff}
              onChange={(e) => {
                const tariff = tariffs.find((t) => t.id === e)
                setState((prev) => ({
                  ...initState,
                  direction: prev.direction,
                  hourCost: tariff?.first_price,
                  defaultDuration: tariff?.lesson_duration ?? 60,
                  tariff: e,
                  newPaymentForDerection: tariff?.type !== 'free',
                }))
                const attachedGroup = curseGroups?.find(
                  (item) => item?.value === tariff?.attached_groups,
                )
                setAttachedGroup(attachedGroup)
              }}
              filterSort={filterSort}
              options={
                tariffs?.map(({ name: label, id: value }) => ({
                  label,
                  value,
                })) ?? []
              }
            />
          </div>
        )}
        {[
          'stream_custom_period',
          'stream_custom_days',
          'stream_custom_weeks',
          'free',
          'month',
          'stream_one_time',
          'group_per_lesson',
        ]?.includes(tariffType) && (
          <div className={s.selectWithLabel}>
            <div className={s.selectLabel}>Группа</div>
            <SelectField
              placeholder={
                groupOptions.length
                  ? 'Выберите группу'
                  : 'В данной франшизе нет групп'
              }
              notFoundContent="В данной франшизе нет групп"
              value={state.group_id ?? (methodPUT && tariffType === 'group_per_lesson' ? 0 : null)}
              className={s.selectField}
              popupClassName={s.selectFieldPopup}
              onChange={(e) => {
                if (attachedGroup && !methodPUT) return
                if (e === 'create_group') {
                  setCreateGroupModal(true)
                  return
                }
                const group = curseGroups?.find(
                  (group) => group.value === e,
                )
                setGroupSelectionChanged(
                  String(e ?? '') !== String(initialGroupId ?? ''),
                )
                setState((prev) => ({
                  ...prev,
                  group_id: e,
                  hourCost: e === 0 ? prev.hourCost : group?.student_lesson_price ?? prev.hourCost,
                  sum: methodPUT ? prev.sum : group?.is_shared_balance
                    ? group?.shared_balance ?? 0
                    : selectedGroup?.is_shared_balance
                    ? ''
                    : prev.sum,
                }))
              }}
              options={[
                ...(methodPUT && tariffType === 'group_per_lesson' ? [{
                  label: 'Без группы',
                  value: 0,
                  disabled: !!props.data.item?.group?.is_shared_balance,
                  title: props.data.item?.group?.is_shared_balance
                    ? 'Нельзя снять общую группу: у неё общий баланс'
                    : undefined,
                }] : []),
                { label: 'Создать группу', value: 'create_group' },
                ...groupOptions.map((group) => ({ ...group, disabled: group.disabled || (methodPUT && tariffType === 'group_per_lesson' && (group.is_shared_balance) && Number(group.value) !== Number(props.data.item?.group_id)) })),
              ]}
            />
            {attachedGroup && !methodPUT && (
              <div
                className={s.inputTrailingLabel}
                style={{ marginTop: '5px' }}
              >
                У Вас стоит автораспределение учащихся в данную группу,
                отключите это в настройках курса, чтобы изменить группу!
              </div>
            )}
            {isGroupLessonPaymentGroupChanged && (
              <div className={s.groupChangeWarning}>
                При смене группы у учащегося будут удалены все занятия из
                предыдущей группы, по которым у него нет отчёта. Все занятия,
                по которым отчёт уже есть, останутся у учащегося.
              </div>
            )}
          </div>
        )}
        {['group_per_lesson']?.includes(tariffType) && (selectedGroup || methodPUT) && (
          <div className={s.twoColumns}>
            <TooltipWrapper title="Стандартная длительность занятия в группе. Стоимость рассчитывается относительно этого времени.">
              <TextField
                label={'Стандартная длительность занятия'}
                placeholder="60"
                value={Number(selectedGroup?.lesson_duration ?? state.defaultDuration ?? 60)?.toString()}
                onChange={() => {}}
                disabled
              />
            </TooltipWrapper>
            <TooltipWrapper title="Стоимость занятия стандартной длительности. Если занятие короче или дольше, сумма пересчитается.">
              <TextField
                label={'Стоимость занятия'}
                placeholder="0"
                value={state.hourCost}
                onChange={(value) =>
                  setState((prev) => ({
                    ...prev,
                    hourCost: normalizeNumberInput({value}),
                  }))
                }
                inputMode='decimal'
              />
            </TooltipWrapper>
          </div>
        )}
        {isDemoAvailable && (
          <div className={s.demoPeriodBox}>
            <CheckBoxLabel
              value={demoAccess}
              onClick={() => setDemoAccess((prev) => !prev)}
              label="Добавить демо-период"
            />
            {isDemoEnabled && (
              <>
                <div className={s.demoPeriodHint}>
                  Оплата не создаётся. После окончания демо отметка останется до
                  первой оплаты.
                </div>
                <div className={s.selectDateNew}>
                  <DatePicker
                    value={demoPeriodStart}
                    onChange={setDemoPeriodStart}
                    format={dateFormat}
                    placeholder="Начало демо"
                    className={s.datePickerNew}
                  />
                  <DatePicker
                    value={demoPeriodEnd}
                    onChange={setDemoPeriodEnd}
                    format={dateFormat}
                    placeholder="Окончание демо"
                    className={s.datePickerNew}
                    disabledDate={(date) =>
                      Boolean(
                        demoPeriodStart &&
                          date?.isBefore(demoPeriodStart, 'day'),
                      )
                    }
                  />
                </div>
              </>
            )}
          </div>
        )}
        {methodPUT && tariffType === 'group_per_lesson' && lessonPriceChanged && (
          <>
            <CheckBoxLabel
              value={recalculatePast}
              onClick={() => setRecalculatePast((prev) => !prev)}
              label="Изменить цену за занятия и за прошлые занятия"
            />
            {shouldRecalculatePast && (
              <div className={s.selectWithLabel}>
                <div className={s.selectLabel}>Выберите, с какого периода изменить стоимость на новую</div>
                <DatePicker
                  value={recalculateFrom}
                  onChange={setRecalculateFrom}
                  format="DD.MM.YYYY"
                  placeholder="Выберите дату"
                  disabled={loadingLessonDates || lessonDatesFailed}
                  disabledDate={(date) => date && date.isAfter(dayjs(), 'day')}
                  dateRender={renderLessonDate}
                />
                <div>{loadingLessonDates ? 'Загружаются даты занятий…' : 'Кружком отмечены проведенные занятия и платные отмены. Перерасчет — с выбранной даты включительно.'}</div>
              </div>
            )}
          </>
        )}
        {[
          'month',
          'stream_custom_period',
          'stream_custom_days',
          'stream_custom_weeks',
          'stream_one_time',
        ]?.includes(tariffType) && !isDemoEnabled && (
          <>
            {/* <Input.InputNew className={s.input} {...bindMonths} /> */}
            {isUniversalBalance ? (
              <div style={{ fontSize: '13px' }}>
                При включенным едином балансе в ЛК ученика это значение всегда 0
              </div>
            ) : (
              <></>
            )}
            {
              <CheckBoxLabel
                value={state.newPaymentForDerection}
                onClick={() => {
                  setState((prev) => ({
                    ...prev,
                    newPaymentForDerection: !prev.newPaymentForDerection,
                  }))
                }}
                label="Новая оплата"
              />
            }
            {tariffType !== 'stream_one_time' && (
              <div className={s.selectWithLabel}>
                <div className={s.selectLabel}>Промежуток времени</div>
                <div className={s.selectDateNew}>
                  <DatePicker
                    value={state.paidFromDateForDerection}
                    onChange={onChangePaidFromDateForDerection}
                    format={dateFormat}
                    placeholder="С какого числа оплачено направлени"
                    className={s.datePickerNew}
                  />
                  <DatePicker
                    value={state.paidBeforeDateForDerection}
                    onChange={onChangePaidBeforeDateForDerection}
                    format={dateFormat}
                    placeholder="До какого числа оплеченно направление"
                    className={s.datePickerNew}
                  />
                </div>
              </div>
            )}
          </>
        )}
        {(tariffType === 'hour' || tariffType === 'minute') && (
          <>
            {getSelectedTariff()?.any_seminarian ? (
              <Input.InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                title={'Учитель'}
                value={'Любой учитель'}
                disabled
              />
            ) : (
              <div className={s.selectWithLabel}>
                <div className={s.selectLabel}>Учитель</div>
                <SelectNew
                  wrapperClassName={s.wrapperSelect}
                  className={s.selectNew}
                  fields={fieldsAllEmployees}
                />
                {!!selectedSeminarian &&
                !hasBaseRole(selectedSeminarian?.roles,rolesEnum.seminarian) ? (
                  <Text
                    texts={[
                      'У данного сотрудника нет роли педагога, она добавится ему автоматически при добавлении ему этого курса',
                    ]}
                  />
                ) : !!selectedSeminarian &&
                  !selectedSeminarian?.directions?.some(
                    (direction) =>
                      Number(direction.id) === Number(state.direction),
                  ) ? (
                  <Text
                    texts={[
                      'У этого сотрудника нет доступа к этому курсу. При добавлении этого курса учащемуся с этим сотрудником система автоматически добавит ему доступ к этому курсу.',
                    ]}
                  />
                ) : (
                  <></>
                )}
              </div>
            )}
            {!withoutTeacher && <Input.InputNew
              className={classNames(s.input, s.removeBoxShadow)}
              {...bindDefaultDuration}
            />}
            {!methodPUT && !getSelectedTariff()?.any_seminarian && (
              <Input.InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                {...bindPrivateLessonLink}
              />
            )}
            {!withoutTeacher && <div className={s.twoColumns}>
              {!getSelectedTariff()?.any_seminarian && (
                <Input.InputNew
                  className={classNames(s.input, s.removeBoxShadow)}
                  {...bindSalaryPerHour}
                />
              )}
              <Input.InputNew
                id={'inputFloatIfNotRub'}
                className={classNames(s.input, s.removeBoxShadow)}
                {...bindHourCost}
              />
            </div>}
            {lessonPriceChanged && (
              <>
                <CheckBoxLabel
                  value={recalculatePast}
                  onClick={() => setRecalculatePast((prev) => !prev)}
                  label="Изменить цену за занятия и за прошлые занятия"
                />
                {shouldRecalculatePast && (
                  <div className={s.selectWithLabel}>
                    <div className={s.selectLabel}>Выберите, с какого периода изменить стоимость на новую</div>
                    <DatePicker
                      value={recalculateFrom}
                      onChange={setRecalculateFrom}
                      format="DD.MM.YYYY"
                      placeholder="Выберите дату"
                      disabled={loadingLessonDates || lessonDatesFailed}
                      disabledDate={(date) => date && date.isAfter(dayjs(), 'day')}
                      dateRender={renderLessonDate}
                    />
                    <div>{loadingLessonDates ? 'Загружаются даты занятий…' : 'Кружком отмечены проведенные занятия и платные отмены. Перерасчет — с выбранной даты включительно.'}</div>
                  </div>
                )}
              </>
            )}
            {!withoutTeacher && <div className={s.additionalTeachersSwitch}>
              <Switch
                checked={state.hasAdditionalTeachers}
                onChange={(checked) =>
                  setState((prev) => ({
                    ...prev,
                    hasAdditionalTeachers: checked,
                    additionalTeacherIds: checked
                      ? prev.additionalTeacherIds
                      : [],
                  }))
                }
              />
              <span>Добавить дополнительных педагогов</span>
              <NewTooltipWrapper title={ADDITIONAL_TEACHERS_TOOLTIP}>
                <InfoCircleOutlined className={s.infoIcon} />
              </NewTooltipWrapper>
            </div>}
            {!withoutTeacher && state.hasAdditionalTeachers && (
              <div className={s.selectWithLabel}>
                <div className={s.selectLabel}>Дополнительные педагоги</div>
                <Select
                  mode="multiple"
                  showSearch
                  className={s.additionalTeachersSelect}
                  placeholder="Выберите педагогов"
                  value={state.additionalTeacherIds}
                  onChange={(additionalTeacherIds) =>
                    setState((prev) => ({
                      ...prev,
                      additionalTeacherIds,
                    }))
                  }
                  options={additionalTeacherOptions}
                  loading={loadingAllEmployees}
                  optionFilterProp="label"
                />
              </div>
            )}
          </>
        )}
        {!methodPUT &&
          tariffType !== 'free' &&
          !isUniversalBalance &&
          !isDemoEnabled && (
          <>
            <Input.InputNew
              className={classNames(s.input, s.removeBoxShadow)}
              {...bindSum}
            />
            {isManualPaymentTypeSelectionEnabled && (
              <div className={s.selectWithLabel}>
                <div className={s.selectLabel}>Тип ручного платежа</div>
                <Select
                  showSearch
                  allowClear
                  className={classNames(
                    s.select,
                    s.removeBoxShadow,
                    s.customSelect,
                  )}
                  placeholder="Не выбрано"
                  optionFilterProp="label"
                  value={manualPaymentType}
                  onChange={setManualPaymentType}
                  filterSort={filterSort}
                  options={manualPaymentTypes.map((typeName) => ({
                    label: typeName,
                    value: typeName,
                  }))}
                />
              </div>
            )}
          </>
        )}
        {shouldShowPrivateSchedule && (
          <PrivateSchedulePlanner
            schedule={privateSchedule}
            onChange={setPrivateSchedule}
            teacherId={state.teacherId}
            durationMinutes={state.defaultDuration}
          />
        )}
        {!methodPUT && (isIndividual || tariffType === 'group_per_lesson') && (
          <CheckBoxLabel
            value={state.newPaymentForDerection}
            onClick={() => {
              setState((prev) => ({
                ...prev,
                newPaymentForDerection: !prev.newPaymentForDerection,
              }))
            }}
            label="Новая оплата"
          />
        )}
      </div>
      <div className={s.footerBtn}>
        <Button
          name={methodPUT ? 'Обновить' : 'Добавить'}
          className={s.buttonPrimary}
          newDesign
          action={save}
          disable={process}
          loading={process}
        />
      </div>
      <CreateGroupModal
        open={createGroupModal}
        directionId={state.direction ?? null}
        onClose={() => setCreateGroupModal(false)}
        onSuccess={onGroupCreated}
        defaultLessonDuration={getSelectedTariff()?.lesson_duration ?? 60}
        studentLessonPrice={Number(getSelectedTariff()?.first_price ?? 0)}
        groupType={
          tariffType === 'group_per_lesson' ? 'lesson-payment' : undefined
        }
        allowedFranchiseIds={props.state.franchise_ids}
      />
      {conflictsModal}
    </>
  )
}

const AddClass = (props) => {
  const dispatch = useDispatch()
  const addAlert = useAddAlert()
  const isTransferMode = props.data?.mode === 'transferClass'
  const [process, setProcess] = useState(false)
  const [classes, setClasses] = useState([])
  const [selectedClass, setSelectedClass] = useState(null)
  const [demoAccess, setDemoAccess] = useState(false)
  const [demoPeriodStart, setDemoPeriodStart] = useState(dayjs())
  const [demoPeriodEnd, setDemoPeriodEnd] = useState(dayjs().add(6, 'day'))
  const isDemoEnabled = !isTransferMode && !!selectedClass?.id && demoAccess
  const [errorsList, setErrorsList] = useState([])
  const [showErrors, setShowErrors] = useState(false)
  const isManualPaymentTypeSelectionEnabled = useSelector(
    (store) => store.settings.isManualPaymentTypeSelectionEnabled === '1',
  )
  const manualPaymentTypes = parseManualPaymentTypes(
    useSelector((store) => store.settings.custom.manualPaymentTypes),
  )
  const [manualPaymentType, setManualPaymentType] = useState(null)
  useEffect(() => {}, [showErrors])

  // const [bindClass] = useInputNew({
  //   title: 'Класс',
  //   name: 'class',
  //   value: selectedClass?.id,
  //   onChange: (value) => {
  //     setNewPaymentForClass(false);
  //     setPaidBefore(null);
  //     setPaidBeforeDate(null);
  //     setPaidFrom(null);
  //     setPaidFromDate(null);
  //     setSelectedClass(classes.find(({id}) => id === value))
  //     setErrorsList([])
  //   },
  //   placeholder: 'Выберите класс',
  //   options: classes
  //     ?.filter(({ id }) => !getInArr(id, props.data?.selected || []))
  //     ?.map(({ title: label, id: value }) => ({ label, value })),
  // });

  const [bindAmount] = useInputNew({
    title: (
      <span className={s.labelWithInfo}>
        Сумма оплаты
        <Tooltip title="Введите, сколько пользователь оплатил за доступ к классу/траектории">
          <InfoCircleOutlined className={s.infoIcon} />
        </Tooltip>
      </span>
    ),
    name: 'amount',
    value: selectedClass?.payment_amount ?? 0,
    onChange: (amount) =>
      setSelectedClass({
        ...selectedClass,
        payment_amount: amount ?? 0,
      }),
    type: 'number',
    placeholder: 'Введите стоимость',
    onError: setErrorsList,
    validate: showErrors,
    errorText: 'Введите стоимость за один месяц занятий',
  })

  useEffect(() => {
    if (selectedClass && selectedClass?.one_pay) {
      if (isTransferMode) return

      setSelectedClass({
        ...selectedClass,
        payment_amount: Number(selectedClass.amount),
        payment_month_amount: Number(selectedClass.amount),
        month_discount: 0,
      })
    }
  }, [selectedClass?.id])

  useEffect(() => {
    classApi.index().then(({ data }) => setClasses(data.data ?? []))
  }, [])

  const [paidBefore, setPaidBefore] = useState(null)
  const [paidBeforeDate, setPaidBeforeDate] = useState(null)
  const [newPaymentForClass, setNewPaymentForClass] = useState(false)
  const [isBackdateTransfer, setIsBackdateTransfer] = useState(false)
  const [transferDate, setTransferDate] = useState(null)

  const onChangeDate = (date, dateString) => {
    setPaidBefore(dateString)
    setPaidBeforeDate(date)
  }

  const [paidFrom, setPaidFrom] = useState(null)
  const [paidFromDate, setPaidFromDate] = useState(null)

  const onChangePaidFrom = (date, dateString) => {
    setPaidFrom(dateString)
    setPaidFromDate(date)
  }

  const dateFormat = 'YYYY.MM.DD'
  const getEntityId = (value) => {
    const id = Number(value)

    return Number.isFinite(id) && id > 0 ? id : null
  }
  const getClassGroupId = (group) => getEntityId(group?.id ?? group?.group_id)
  const getClassGroupDirectionId = (group) =>
    getEntityId(group?.direction_id ?? group?.direction?.id)
  const getOrderId = (order) => getEntityId(order?.id)
  const getOrderGroupId = (order) => getEntityId(order?.group_id ?? order?.group?.id)
  const getOrderDirectionId = (order) =>
    getEntityId(order?.direction_id ?? order?.direction?.id)

  const ensureClassGroupsAttached = async (classId, skipped = []) => {
    const userId = props.state?.id

    if (!classId || !userId) return

    const [classResponse, ordersResponse] = await Promise.all([
      classApi.show(classId),
      directionOrdersApi.get({
        filter: [
          `[children_id][eq]=${userId}`,
          `[class_id][eq]=${classId}`,
          '[is_disabled][eq]=0',
        ],
        expand: ['group', 'direction'],
        pageSize: false,
      }),
    ])
    const classGroups =
      classResponse?.data?.data?.groups ?? selectedClass?.groups ?? []
    const activeOrders = ordersResponse?.data?.data ?? []
    const attachedGroupIds = new Set(
      activeOrders.map(getOrderGroupId).filter(Boolean),
    )
    const directionsWithGroup = new Set(
      activeOrders
        .filter((order) => getOrderGroupId(order))
        .map(getOrderDirectionId)
        .filter(Boolean),
    )
    const skippedPairs = new Set(
      skipped.map(({ course_id, group_id }) => `${course_id}:${group_id}`),
    )
    const usedGroupIds = new Set()
    const usedDirectionIds = new Set()
    const missingGroups = classGroups.filter((group) => {
      const groupId = getClassGroupId(group)
      const directionId = getClassGroupDirectionId(group)

      if (skippedPairs.has(`${directionId}:${groupId}`)) return false

      if (!groupId || usedGroupIds.has(groupId) || attachedGroupIds.has(groupId)) {
        return false
      }

      usedGroupIds.add(groupId)

      if (!directionId) return true

      if (usedDirectionIds.has(directionId) || directionsWithGroup.has(directionId)) {
        return false
      }

      usedDirectionIds.add(directionId)

      return true
    })

    if (!missingGroups.length) return

    const results = await Promise.allSettled(
      missingGroups.map((group) => {
        const groupId = getClassGroupId(group)
        const directionId = getClassGroupDirectionId(group)
        const orderWithoutGroup = activeOrders.find(
          (order) =>
            directionId &&
            getOrderDirectionId(order) === directionId &&
            !getOrderGroupId(order) &&
            getOrderId(order),
        )

        if (orderWithoutGroup) {
          return directionGroupApi.moveStudentsToGroup({
            direction_orders_ids: [getOrderId(orderWithoutGroup)],
            new_group_id: groupId,
          })
        }

        return classApi.attachUserClassGroup(classId, {
          user_id: userId,
          group_id: groupId,
        })
      }),
    )
    const failedRequest = results.find(({ status }) => status === 'rejected')

    if (failedRequest) {
      throw failedRequest.reason
    }
  }

  const save = () => {
    if (isTransferMode) {
      if (!selectedClass?.id) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Нужно выбрать класс/траекторию',
        })
        return
      }

      if (isBackdateTransfer && !transferDate) {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: 'Нужно выбрать дату перевода задним числом',
        })
        return
      }

      setProcess(true)
      dispatch(
        openPreloader({ text: 'Идет перевод класса', showMenu: false }),
      )

      classApi
        .transferPaidClass({
          user_id: props.state?.id,
          from_class_id: props.data?.fromClassId,
          to_class_id: selectedClass.id,
          transfer_date: isBackdateTransfer
            ? transferDate?.format('YYYY-MM-DD')
            : undefined,
        })
        .then((res) => {
          if (res.data?.status !== 'success') {
            props.data?.onError?.(res.response ?? res)
          } else {
            props.data?.onSuccess?.(res)
            props.close()
            addAlert({
              title: 'Класс переведен!',
            })
          }
        })
        .catch((error) => {
          props.data?.onError?.(error.response ?? error)
        })
        .finally(() => {
          dispatch(closePreloader())
          setProcess(false)
        })

      return
    }

    if (
      isDemoEnabled &&
      (!demoPeriodStart?.isValid() || !demoPeriodEnd?.isValid() ||
        demoPeriodEnd.isBefore(demoPeriodStart, 'day'))
    ) {
      addAlert({
        type: 'error', title: 'Ошибка',
        text: 'Проверьте даты начала и окончания демо-периода',
      })
      return
    }
    if (
      !isDemoEnabled && selectedClass?.one_pay &&
      (paidFrom == null ||
        paidFrom?.length < 4 ||
        paidBefore == null ||
        paidBefore?.length < 4)
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Необходимо указать даты, с какого момента оплачен класс и до какого',
      })
      return
    }
    if (
      !isDemoEnabled && selectedClass?.one_pay &&
      Number(paidFrom.replace(/\./gi, '')) >
        Number(paidBefore.replace(/\./gi, ''))
    ) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Дата до которой оплачен класс не может быть меньше даты оплаты',
      })
      return
    }
    setShowErrors(true)

    if (isDemoEnabled || errorsList.valid || !selectedClass.one_pay) {
      setProcess(true)
      dispatch(
        openPreloader({ text: 'Идет добавление класса', showMenu: false }),
      )

      classApi
        .attachChildren(selectedClass.id, {
          user_id: props.state?.id,
          amount: isDemoEnabled ? 0 : selectedClass.payment_amount,
          month_amount: selectedClass.payment_month_amount,
          month_discount: selectedClass.month_discount,
          paid_from:
            !isDemoEnabled && paidFrom != null && paidFrom?.length > 3
              ? paidFrom.replace(/\./gi, '-')
              : null,
          next_payment_date:
            !isDemoEnabled && paidBefore != null && paidBefore?.length > 3
              ? paidBefore.replace(/\./gi, '-')
              : null,
          demo_access: isDemoEnabled,
          demo_started_at: isDemoEnabled ? demoPeriodStart.startOf('day').format() : undefined,
          demo_ends_at: isDemoEnabled ? demoPeriodEnd.endOf('day').format() : undefined,
          status_payment: isDemoEnabled ? false : selectedClass?.one_pay ? true : null,
          new_payment: isDemoEnabled ? false : newPaymentForClass,
          manual_payment_type: isDemoEnabled ? null : manualPaymentType,
        })
        .then(async (res) => {
          if (res.data?.status !== 'success') {
            props.data?.onError?.(res.response)
          } else {
            const skipped = res.data?.data?.skipped ?? []
            let hasGroupAttachError = false

            try {
              await ensureClassGroupsAttached(selectedClass.id, skipped)
            } catch {
              hasGroupAttachError = true
            }

            props.data?.onSuccess?.(res)
            props.close()
            addAlert({
              type: hasGroupAttachError ? 'error' : undefined,
              title: hasGroupAttachError
                ? 'Класс добавлен, но не все группы подтянулись'
                : 'Класс добавлен!',
              text: skipped.length
                ? 'Некоторые курсы не были добавлены, потому что ученик уже состоит в этих же группах по данным курсам в другом классе.'
                : undefined,
            })
          }
        })
        .catch((error) => {
          props.data?.onError?.(error.response ?? error)
        })
        .finally(() => {
          dispatch(closePreloader())
          setProcess(false)
        })
    }
  }

  return (
    <>
      {isTransferMode ? (
        <div className={s.transferTitleBlock}>
          <h2 className="modal__title">Перевод в другой класс/траекторию</h2>
          <div className={s.transferTitleInfo}>
            <InfoCircleOutlined className={s.transferInfoIcon} />
            <span>Из платного класса можно перевести только в другой платный класс</span>
          </div>
        </div>
      ) : (
        <h2 className="modal__title">Добавить класс/траекторию</h2>
      )}

      <div className={s.body}>
        <div className={s.selectWithLabel}>
          <div className={s.selectLabel}>Класс</div>
          <Select
            showSearch
            className={classNames(s.select, s.removeBoxShadow, s.customSelect)}
            placeholder="Выберите класс"
            optionFilterProp="label"
            value={selectedClass?.id}
            onChange={(value) => {
              const newClass = classes.find(({ id }) => id === value)
              const beforeData = newClass?.auto_access_duration
                ? dayjs().add(
                    newClass?.auto_access_duration,
                    newClass?.auto_access_unit === 'days' ? 'day' : 'month',
                  )
                : null
              const before = beforeData ? beforeData.format(dateFormat) : null

              setPaidBefore(before)
              setPaidBeforeDate(beforeData)
              setPaidFrom(dayjs().format(dateFormat))
              setPaidFromDate(dayjs())
              setSelectedClass(newClass)
              setDemoAccess(false)
              setDemoPeriodStart(dayjs())
              setDemoPeriodEnd(dayjs().add(6, 'day'))
              setNewPaymentForClass(!!newClass?.one_pay)
              setErrorsList([])
            }}
            filterSort={(optionA, optionB) =>
              (optionA?.label ?? '')
                .toLowerCase()
                .localeCompare((optionB?.label ?? '').toLowerCase())
            }
            options={classes
              ?.filter(
                ({ id, one_pay }) =>
                  !getInArr(id, props.data?.selected || []) &&
                  (!isTransferMode || Number(one_pay) === 1),
              )
              ?.map(({ title: label, id: value }) => ({ label, value }))}
          />
        </div>

        {/* <Input.InputSelect className={s.input} {...bindClass} /> */}

        {isTransferMode && selectedClass && (
          <>
            <div className={s.transferHint}>
              <Tooltip
                title={transferPaymentTooltip}
                placement="topLeft"
                overlayClassName={s.transferPaymentTooltipOverlay}
              >
                <InfoCircleOutlined className={s.transferInfoIcon} />
              </Tooltip>
              <span className={s.transferHintText}>
                Оплаченный период предыдущего класса перенесется на текущий
                класс. Сумма оплаты частично перейдет на новый класс.
              </span>
            </div>
            <div className={s.transferBackdate}>
              <CheckBoxLabel
                value={isBackdateTransfer}
                onClick={() => {
                  setIsBackdateTransfer((prev) => !prev)
                  setTransferDate(null)
                }}
                label="Перевести в другой класс задним числом"
              />
              {isBackdateTransfer && (
                <DatePicker
                  value={transferDate}
                  onChange={setTransferDate}
                  format={dateFormat}
                  placeholder="Выберите прошедшую дату"
                  className={s.datePickerNew}
                  disabledDate={(current) =>
                    current && !current.isBefore(dayjs(), 'day')
                  }
                />
              )}
            </div>
          </>
        )}

        {!isTransferMode && selectedClass && (
          <div className={s.demoPeriodBox}>
            <CheckBoxLabel
              value={demoAccess}
              onClick={() => setDemoAccess(prev => !prev)}
              label="Добавить демо-период"
            />
            {isDemoEnabled && (
              <>
                <div className={s.demoPeriodHint}>Оплата не создаётся. После окончания демо отметка останется до первой оплаты.</div>
                <div className={s.selectDateNew}>
                  <DatePicker
                    value={demoPeriodStart}
                    onChange={setDemoPeriodStart}
                    format={dateFormat}
                    placeholder="Начало демо"
                    className={s.datePickerNew}
                  />
                  <DatePicker
                    value={demoPeriodEnd}
                    onChange={setDemoPeriodEnd}
                    format={dateFormat}
                    placeholder="Окончание демо"
                    className={s.datePickerNew}
                    disabledDate={date => !!demoPeriodStart && date?.isBefore(demoPeriodStart, 'day')}
                  />
                </div>
              </>
            )}
          </div>
        )}
        {!isTransferMode && selectedClass && !isDemoEnabled &&
          (selectedClass?.one_pay ? (
            <>
              <div>Базовая стоимость, мес: {selectedClass.amount} ₽</div>
              <InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                {...bindAmount}
              />
              <InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                title={
                  <span className={s.labelWithInfo}>
                    Стоимость класса (мес.)
                    <Tooltip title="Это стандартная стоимость обучения за месяц в этом классе">
                      <InfoCircleOutlined className={s.infoIcon} />
                    </Tooltip>
                  </span>
                }
                name="monthPrice"
                value={selectedClass?.payment_month_amount ?? 0}
                onChange={(e) =>
                  setSelectedClass({
                    ...selectedClass,
                    payment_month_amount: e?.target?.value,
                    month_discount: 0,
                  })
                }
                type="number"
                placeholder="0"
                onError={setErrorsList}
                validate={showErrors}
                errorText="Введите стоимость за один месяц занятий"
              />
              <InputNew
                className={classNames(s.input, s.removeBoxShadow)}
                title="Скидка (мес.)"
                name="monthDiscount"
                value={selectedClass?.month_discount ?? 0}
                onChange={(e) => {
                  const value = e?.target?.value
                  if (
                    Number(value) <=
                      Number(selectedClass?.payment_month_amount) ??
                    0
                  )
                    setSelectedClass({
                      ...selectedClass,
                      month_discount: e?.target?.value,
                    })
                }}
                type="number"
                placeholder="0"
                onError={setErrorsList}
                validate={showErrors}
                errorText="Введите скидку за один месяц занятий"
              />
              {isManualPaymentTypeSelectionEnabled && (
                <div className={s.selectWithLabel}>
                  <div className={s.selectLabel}>Тип ручного платежа</div>
                  <Select
                    showSearch
                    allowClear
                    className={classNames(
                      s.select,
                      s.removeBoxShadow,
                      s.customSelect,
                    )}
                    placeholder="Не выбрано"
                    optionFilterProp="label"
                    value={manualPaymentType}
                    onChange={setManualPaymentType}
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? '')
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? '').toLowerCase())
                    }
                    options={manualPaymentTypes.map((typeName) => ({
                      label: typeName,
                      value: typeName,
                    }))}
                  />
                </div>
              )}
            </>
          ) : (
            <Alert
              message="Оплата за данный класс производится отдельно по каждому направлению"
              type="info"
            />
          ))}
        {!isTransferMode && selectedClass && selectedClass?.one_pay && !isDemoEnabled && (
          <div style={{ width: '100%' }}>
            <CheckBoxLabel
              value={newPaymentForClass}
              onClick={() => {
                setNewPaymentForClass((prev) => !prev)
              }}
              style={{ marginBottom: '10px' }}
              label="Новая оплата"
            />
            <div className={s.selectWithLabel}>
              <div className={s.selectLabel}>Промежуток времени</div>
              <div className={s.selectDateNew}>
                <DatePicker
                  value={paidFromDate}
                  onChange={onChangePaidFrom}
                  format={dateFormat}
                  placeholder="С какого числа оплачен класс"
                  className={s.datePickerNew}
                />
                <DatePicker
                  value={paidBeforeDate}
                  onChange={onChangeDate}
                  format={dateFormat}
                  placeholder="До какого числа оплачен класс"
                  className={s.datePickerNew}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={s.footerBtn}>
        {/* <button onClick={props.close} className={s.buttonCancel}>
          Отмена
        </button> */}
        <Button
          name={isTransferMode ? 'Перевести' : 'Добавить'}
          action={save}
          disable={process || !selectedClass}
          loading={process}
          newDesign
          className={s.buttonPrimary}
        />
      </div>
    </>
  )
}

const AddGroupToClass = (props) => {
  const [process, setProcess] = useState(false)
  const [groups, setGroups] = useState([])
  const [selectedGroup, setSelectedGroup] = useState(null)

  const groupOptions = groups
    ?.filter(({ id, direction }) =>
      props?.data?.filterByDirection
        ? !getInArr(direction.id, props.data?.selected || [])
        : !getInArr(id, props.data?.selected || []),
    )
    ?.map(({ name: label, id: value }) => ({ label, value }))
    ?.sort((optionA, optionB) =>
      (optionA?.label ?? '')
        .toLowerCase()
        .localeCompare((optionB?.label ?? '').toLowerCase()),
    )

  useEffect(() => {
    classApi
      .show(props.data.classId)
      .then(({ data }) => setGroups(data.data.groups ?? []))
  }, [])

  const save = () => {
    setProcess(true)

    classApi
      .attachUserClassGroup(props.data.classId, {
        user_id: props.state?.id,
        group_id: selectedGroup,
      })
      .then((res) => {
        if (res.response?.status >= 400) {
          props.data?.onError?.(res.response)
        } else {
          props.data?.onSuccess?.(res)
          props.close()
        }
      })
      .finally(() => setProcess(false))
  }

  return (
    <>
      <div className={s.transferTitleBlock}>
        <h2 className="modal__title">Добавить группу</h2>
        <div className={s.transferTitleInfo}>
          <InfoCircleOutlined className={s.transferInfoIcon} />
          <span>
            Выберите группу из курсов, которые привязаны к этому классу/траектории.
          </span>
        </div>
      </div>

      <div className={s.body}>
        <div className={s.selectWithLabel}>
          <div className={s.selectLabel}>Группа</div>
          <Select
            showSearch
            className={classNames(s.select, s.removeBoxShadow, s.customSelect)}
            placeholder="Выберите группу"
            optionFilterProp="label"
            value={selectedGroup}
            onChange={setSelectedGroup}
            options={groupOptions}
          />
        </div>
      </div>

      <div className={s.footerBtn}>
        <Button
          name={'Отмена'}
          action={props.close}
          newDesign
          className={s.buttonCancel}
        />
        <Button
          name={'Добавить'}
          action={save}
          disable={process || !selectedGroup}
          loading={process}
          newDesign
          className={s.buttonPrimary}
        />
      </div>
    </>
  )
}

const ChangePassword = (props) => {
  const [errorsList, setErrorsList] = React.useState([])
  const [showErrors, setShowErrors] = React.useState(false)

  const [oldPassword, setOldPassword] = React.useState()
  const [bindOldPassword] = useInputNew({
    name: 'oldPassword',
    value: oldPassword,
    onChange: setOldPassword,
    onError: setErrorsList,
    placeholder: 'Введите старый пароль',
    validate: showErrors,
    type: 'password',
    errorText: 'Заполните старый пароль',
  })

  const [password, setPassword] = React.useState()
  const [bindPassword] = useInputNew({
    name: 'password',
    value: password,
    onChange: setPassword,
    onError: setErrorsList,
    placeholder: 'Введите новый пароль',
    validate: showErrors,
    type: 'password',
    errorText: 'Заполните пароль',
  })

  const [passwordRepeat, setPasswordReplay] = React.useState('')
  const [showErrorReplay, setShowErrorReplay] = React.useState(false)
  const [bindPasswordReplay] = useInputNew({
    name: 'password_replay',
    value: passwordRepeat,
    onChange: setPasswordReplay,
    onError: setErrorsList,
    placeholder: 'Повторите новый пароль',
    validate: showErrorReplay,
    type: 'password',
    errorText: 'Пароли не совпадают',
    typeValid: (val) => val !== password,
    onBlur: () => setShowErrorReplay(true),
  })

  const save = () => {
    setShowErrors(true)
    if (errorsList.valid) {
      const data = {
        currentPassword: oldPassword,
        newPassword: password,
        passwordRepeat: passwordRepeat,
      }
      usersAPI.changePassword({ id: props.state.id, data }).then((res) => {
        if (res.data?.data?.id !== undefined) props.setModal('PasswordChanged')
      })
    }
  }

  return (
    <>
      <h2 className="modal__title">Изменить пароль</h2>
      <div className={s.body}>
        <Input.InputNew className={s.input} {...bindOldPassword} />
        <Input.InputNew className={s.input} {...bindPassword} />
        <Input.InputNew className={s.input} {...bindPasswordReplay} />

        <button
          className={s.link}
          onClick={() => props.setModal('RecoverPassword')}
        >
          Восстановить пароль
        </button>
      </div>
      <div className={s.footerBtn}>
        <Button name="Изменить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const PasswordChanged = (props) => {
  const save = () => props.close()
  return (
    <>
      <h2 className="modal__title">Пароль изменён!</h2>
      <div className={s.body}></div>
      <div className={s.footerBtn}>
        <Button name="Хорошо" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RecoverPassword = (props) => {
  const [status, setStatus] = React.useState(null)
  const [error, setError] = React.useState(null)
  const [customPassword, setCustomPassword] = React.useState(false)
  const [newPassword, setNewPassword] = React.useState(null)
  const save = () => props.close()
  const recover = () => {
    usersAPI
      .resetPassword({
        id: props.state.id,
        data: { custom_password: customPassword, password: newPassword },
      })
      .then((res) => {
        setStatus(res?.data?.status ?? res?.response?.data?.status)
        setError(res?.data?.error ?? res?.response?.data?.error ?? null)
      })
  }
  return (
    <>
      <h2 className="modal__title">Восстановить пароль</h2>
      <div className={s.body}>
        <div>
          <div className={s.row}>
            <CheckBoxLabel
              value={customPassword}
              onClick={() => setCustomPassword(!customPassword)}
              label="Задать новый пароль вручную"
            />
          </div>
          {customPassword && (
            <InputNew
              title={'Введите новый пароль'}
              style={{ marginTop: '1rem' }}
              onChange={(e) => setNewPassword(e.target.value)}
            ></InputNew>
          )}
        </div>
        <p>
          {status === null
            ? 'Нажмите кнопку отправить для сброса пароля'
            : status === 'error'
            ? error ?? 'Невозможно сбросить пароль'
            : 'Пароль успешно сброшен. Новый пароль отправлен на почту.'}
        </p>
      </div>
      <div className={s.footerBtn}>
        {status ? (
          <Button name="Хорошо" styles="yellow" action={save} />
        ) : (
          <>
            <Button name="Отправить" styles="yellow" action={recover} />
            <Button name="Отмена" styles="yellow" action={save} />
          </>
        )}
      </div>
    </>
  )
}

const Password = (props) => {
  const [password, setPassword] = React.useState()
  const [bindPassword] = useInputNew({
    name: 'password',
    value: password,
    onChange: setPassword,
    placeholder: 'Введите новый пароль',
    errorText: 'Заполните пароль',
  })

  const save = () => props.close()
  return (
    <>
      <h2 className="modal__title">Изменить пароль</h2>
      <div className={s.body}>
        <Input.InputNew className={s.input} {...bindPassword} />
      </div>
      <div className={s.footerBtn}>
        <Button name="Сохранить" styles="yellow" action={save} />
      </div>
    </>
  )
}

const RemoveDirection = (props) => {
  const dispatch = useDispatch()
  const addAlert = useAddAlert()
  const [disabledByStudent, setDisabledByStudent] = useState(false)
  const [keepUncompletedHomework, setKeepUncompletedHomework] = useState(true)
  const [disableComment, setDisableComment] = useState('')
  const [removing, setRemoving] = useState(false)

  const save = useCallback(() => {
    if (removing) return

    const sendData = {
      disabled_by_student: disabledByStudent,
      disable_comment: disabledByStudent ? disableComment : '',
      keepUncompletedHomework,
    }

    setRemoving(true)
    dispatch(
      openPreloader({ text: 'Идет удаление направления', showMenu: false }),
    )

    const removeRequest = directionOrdersApi
      .remove({ id: props.data }, { data: sendData })
      .then(
        () => ({ error: null }),
        (error) => ({ error }),
      )

    Promise.all([
      removeRequest,
      waitMinDeletePreloaderDelay(),
    ])
      .then(([result]) => {
        if (result.error) throw result.error

        props.getDirection()
        props.close()
      })
      .catch((error) => {
        addAlert({
          type: 'error',
          title: 'Ошибка',
          text: error?.response?.data?.message ?? 'Не удалось удалить направление',
        })
      })
      .finally(() => {
        setRemoving(false)
        dispatch(closePreloader())
      })
  }, [
    addAlert,
    disabledByStudent,
    disableComment,
    dispatch,
    keepUncompletedHomework,
    props,
    removing,
  ])

  const saveEnter = (e) => {
    if (e.key === 'Enter') {
      save()
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', saveEnter)
    return () => {
      document.removeEventListener('keydown', saveEnter)
    }
  }, [save])

  return (
    <div className={s.removeDirectionModal}>
      <h2 className="modal__title">Удалить направление</h2>
      <p className={s.removeDirectionDescription}>
        Все индивидуальные занятия с этим учащимся, начиная с сегодняшнего дня,
        автоматически удалятся. Отчеты по предыдущим занятиям останутся
      </p>
      <div className={s.body}>
        <div className={s.wrapperCheckBoxLabel}>
          <CheckBoxLabel
            style={{ marginTop: '10px' }}
            value={keepUncompletedHomework}
            onClick={() =>
              setKeepUncompletedHomework((prevValue) => !prevValue)
            }
            label="Не удалять заданные (не выполненные) дз у ученика"
          />
        </div>
        <div className={s.wrapperCheckBoxLabel}>
          <CheckBoxLabel
            value={disabledByStudent}
            onClick={() => setDisabledByStudent((prevValue) => !prevValue)}
            label="Учащийся слился с обучения"
          />
        </div>

        {disabledByStudent && (
          <div style={{ width: '100%' }}>
            <span
              style={{
                fontSize: '15px',
                marginBottom: '10px',
                display: 'flex',
              }}
            >
              Напишите причину слива учащегося
            </span>
            <Textarea
              value={disableComment}
              onChange={(e) => setDisableComment(e.target.value)}
              placeholder="Причина слива учащегося"
              style={{ width: '100%' }}
            />
          </div>
        )}
      </div>
      <div className={classNames(s.footerBtn, s.removeDirectionFooter)}>
        <Button
          name="Подтвердить действие"
          styles="red"
          action={save}
          disable={removing}
          loading={removing}
        />
      </div>
    </div>
  )
}

const AddWorkHours = (props) => {
  return (
    <WorkHoursEditor
      userId={props.state.id}
      workHours={props.state.workHours}
      onClose={props.close}
      onSaved={props.refreshUser}
    />
  )
}
